<template>
  <span class="bto-sb-event-statistics">
    <a v-if="sportId === zoomSoccerId"
      href="javascript:void(0);"
      :title="t('Match.Zoom.Title')"
      @click="openZoomSoccer()"></a>
    <a v-else
      href="javascript:void(0);"
      :title="t('Match.Statistics.Title')"
      @click="openStatistics()"></a>
  </span>
</template>

<script>
  import { EventBus } from '../../services/event-bus-service';
  import { getZoomUrl, ZOOM_SOCCER_ID  } from 'bto-models/match/zoom';

  export default {
    name: 'StatisticsComponent',
    data() {
      return {
        locale: APP_SETTINGS.player.language,
        provider: APP_SETTINGS.statistics.provider,
        brStatsUrl: APP_SETTINGS.statistics.betradarUrl,
        statscoreLang: this.$root.statscoreLang,
        statscoreConfigId: APP_SETTINGS.statistics.statscoreConfigId,
        zoomSoccerId: ZOOM_SOCCER_ID,
      };
    },
    props: {
      betRadarId: {
        type: [Number, String],
        required: true,
      },
      feedProvider: {
        type: String,
      },
      isAwayAtHome: {
        type: Boolean,
        default: false,
      },
      isLive: {
        type: Boolean,
        default: false,
      },
      sportId: {
        type: Number,
      },
      tournamentName: {
        type: String,
        default: 'Premier',
      },
    },
    methods: {
      openStatistics() {
        if (!this.betRadarId) {
          EventBus.$emit('modalMessage', {
            showModal: true,
            messageType: 'info',
            messageText: this.$translate.text('Mobile.StatisticsNoData'),
            modalSize: 'md',
            modalPossition: '',
          });
          return;
        }
        const h = 600;
        const w = 1000;
        const left = (window.innerWidth / 2) - (w / 2);
        const top = (window.innerHeight / 2) - (h / 2);

        switch (this.provider) {
          case 'betradar': {
            let newUrl = this.brStatsUrl
              .replace('$betRadarId$', this.betRadarId)
              .replace('$locale$', this.locale);
            window.open(newUrl, 'popupWindow', 'width=' + w + ',height=' + h + ',top=' + top + ',left=' + left + ',scrollbars=yes');
            break;
          }
          case 'statscore': {
            const newWindow = window.open(window.location.href, 'popupWindow', 'width=' + w + ',height=' + h + ',top=' + top + ',left=' + left + ',scrollbars=yes');
            let trackerElement = document.createElement('DIV');
            trackerElement.id = `Tracker-${this.betRadarId}`;
            trackerElement.className = 'STATSCORE__Tracker';
            trackerElement.dataset.event = this.betRadarId;
            trackerElement.dataset.lang = this.statscoreLang;
            trackerElement.dataset.config = this.statscoreConfigId;
            trackerElement.dataset.zone = '';
            trackerElement.setAttribute('data-use-mapped-id', 1);

            newWindow.document.body.innerHTML = '';
            newWindow.document.write('<body></body>');
            newWindow.document.title = `${this.t('Match.Statistics.Title')}`;
            newWindow.document.body.appendChild(trackerElement);

            // Display message on event from statscore
            const callbackScript = document.createElement('SCRIPT');
            callbackScript.id = 'cb-script';
            callbackScript.text = ` var errorMsg = function(event) {
                if (event.data.type === 'statscore.livematchpro.error') {
                  const errMsg = document.createElement('P');
                  errMsg.id = 'err-msg';
                  errMsg.innerHTML  = '${this.$translate.text('Mobile.StatisticsNoData')}';
                  document.body.appendChild(errMsg);
                  window.removeEventListener("message", errorMsg);  
                }
              };
              window.addEventListener('message', errorMsg);`;
            newWindow.document.body.appendChild(callbackScript);

            const statscoreScript = document.createElement('SCRIPT');
            statscoreScript.id = 'statscore-script';
            statscoreScript.src = 'https://prematch.statscore.com/livescorepro/generator';

            newWindow.document.body.appendChild(statscoreScript);

            newWindow.document.getElementById('statscore-script').onload = () => {
              newWindow.statscore = new newWindow.Softnetsport.LSP.Generator();
              newWindow.statscore.addTrackersEmbeddedOnPage();
            };
            break;
          }
          case 'statscoreV3':
            this.initStatscoreV3(w, h, top, left);
            break;
          default:
            console.error('statistics provider not set'); // eslint-disable-line
            break;
        }
      },
      initStatscoreV3(w, h, top, left) {
        const newWindow = window.open('', '_blank', 'width=' + w + ',height=' + h + ',top=' + top + ',left=' + left + ',scrollbars=yes' + ',popup');
        let trackerElement = newWindow.document.createElement('DIV');

        newWindow.document.body.innerHTML = '';
        newWindow.document.write('<body></body>');
        newWindow.document.title = `${this.t('Match.Statistics.Title')}`;
        newWindow.document.body.appendChild(trackerElement);

        // Display message on event from statscore
        const statscoreScript = newWindow.document.createElement('SCRIPT');
        statscoreScript.id = 'statscoreV3-script';
        statscoreScript.src = 'https://wgt-s3-cdn.statscore.com/bundle/Embeder.js';

        newWindow.document.head.appendChild(statscoreScript);

        newWindow.STATSCOREWidgets = {};
        newWindow.STATSCOREWidgets.onLoadCallbacks = [];
        newWindow.STATSCOREWidgets.onLoad = function (d) {
          newWindow.STATSCOREWidgets.onLoadCallbacks.push(d);
        };

        newWindow.STATSCOREWidgets.onLoad(err => {
          if (err) {
            // eslint-disable-next-line
            console.log(err);
            return;
          }

          const element = trackerElement;

          // Configuration that you should receive from STATSCORE
          const configurationId = this.isLive ? APP_SETTINGS.liveTracker.statscoreConfigId : APP_SETTINGS.statistics.statscoreConfigId;

          // Feed Provider Codes
          // Betgenius 'bg' - 109
          // Betradar 'sr' - 11
          const providerCode = this.feedProvider === 'bg' ? 109 : 11;

          //Language Code
          const language = window.sportCastCulture == 'pt-BR' ? 'br' : APP_SETTINGS.player.language

          // Input data for widget type you want to embded
          const inputData = { eventId: `m:${this.betRadarId}`, providerId: providerCode, language: language, invertedParticipants: this.isAwayAtHome };

          // Optional object with options.
          const options = { loader: { enabled: true } };

          const widget = new newWindow.STATSCOREWidgets.WidgetGroup(element, configurationId, inputData, options);
          widget.on('error', () => {
            newWindow.document.body.innerHTML = `${this.$translate.text('Mobile.StatisticsNoData')}`;
          });
        });
      },
      openZoomSoccer() {
        const h = 600;
        const w = 1000;
        const left = (window.innerWidth / 2) - (w / 2);
        const top = (window.innerHeight / 2) - (h / 2);

        const url = getZoomUrl(this.betRadarId, this.tournamentName, this.isLive);
     
        window.open(url, 'popupWindow', 'width=' + w + ',height=' + h + ',top=' + top + ',left=' + left + ',scrollbars=yes');
      }
    },
  };
</script>
